import { Pipe, PipeTransform } from '@angular/core';
import { InService } from '@flyfreely-portal-ui/flyfreely';
import { FormatDurationPipe } from 'libs/ui/src/lib/pipes';
import moment, { Moment } from 'moment';

@Pipe({
    name: 'formatInServiceTime'
})
export class FormatInServiceTimePipe implements PipeTransform {
    constructor(private durationPipe: FormatDurationPipe) {}
    /**
     * A formatter pipe that converts an InService object to a string denoting time until service
     * as compared to the comparisonTime.
     * @param time The time in service to display
     * @param comparisonTime The time point to use for the time in service.
     * This can be used to display time in service as it was at a point in time, such as when
     * maintenance was performed, or can be given the current system time for comparisons to now.
     * @returns A string showing the times until the next service
     */
    transform(time: InService, comparisonTime: string | Date | Moment) {
        let ret = '';
        if (time.time != null) {
            ret += `Time: ${this.durationPipe.transform(time.time)} `;
        }
        if (time.cycles != null) {
            ret += `Cycles: ${time.cycles} `;
        }
        if (time.timestamp != null) {
            ret += `Days: ${moment(time.timestamp)
                .startOf('day')
                .diff(moment(comparisonTime).startOf('day'), 'days')}`;
        }
        return ret;
    }
}
